export default class CreatePackRequest {
    code;
    title;
    description;

    static fromJson = (json = {}) => {
        var createPackRequest = new CreatePackRequest();
        createPackRequest = json;
        return createPackRequest;
    }
}